import { render, staticRenderFns } from "./CommonUploadTable.vue?vue&type=template&id=627ff4a2&scoped=true&"
import script from "./CommonUploadTable.vue?vue&type=script&lang=js&"
export * from "./CommonUploadTable.vue?vue&type=script&lang=js&"
import style0 from "./CommonUploadTable.vue?vue&type=style&index=0&id=627ff4a2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627ff4a2",
  null
  
)

export default component.exports